
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "31be4284-5404-4222-b610-c0ec61ae1d33"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
